import { Component, OnInit } from '@angular/core';

import { TickTockService } from '../../services';

@Component({
  selector: 'tick-tock',
  styles: [require('./tick-tock.component.scss')],
  template: require('./tick-tock.component.html'),
})
export class TickTockComponent implements OnInit {
  // Current time string.
  public currentTime: string;

  /**
   * Component constructor with injected dependencies.
   * @param tickTockService
   */
  public constructor(
    private tickTockService: TickTockService
  ) {}

  /**
   * Implements onInit event handler.
   */
  public ngOnInit(): void {
    this.tickTockService.getTick().subscribe(
      (timeString) => this.currentTime = timeString
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/tick-tock/tick-tock.component.ts